var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenzinga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 61,
    viewBox: "0 0 294 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h250.743v34.14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .42h294v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.383 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.117 5.858V0H100.5v6.338h16.084L100.5 28.174v5.805h25.884v-6.338h-16.457l16.19-21.783zm5.806 28.281h7.296V0h-7.296v34.14zm95.707-12.196 5.326-14.647 5.325 14.647H227.63zM237.535 0h-14.007l3.355 4.314-.585 1.651-10.865 28.12h8.202l2.13-5.751h14.647l2.13 5.752h8.201L237.535 0zm-67.479 21.41L154.238 0h-10.811l3.355 4.314v29.772h7.296V11.77l16.298 22.21h6.924V0h-7.244v21.41zm32.754 0h3.782v3.995a11.454 11.454 0 0 1-6.977 2.556c-6.071 0-10.332-4.634-10.332-10.865s4.314-10.865 10.332-10.865c3.142 0 6.071 1.651 7.776 4.314l5.752-3.195C210.693 3.462 206.379 0 199.562 0c-9.64 0-17.63 6.657-17.63 16.99 0 10.332 7.884 16.99 17.63 16.99 5.325.106 10.385-2.184 13.9-6.126V15.285h-15.551l4.9 6.125zM19.972 27.695h-9.427v-7.83h9.427c2.77 0 4.314 1.758 4.314 3.889 0 2.45-1.651 3.887-4.314 3.94zM10.545 6.39h9.107c2.45 0 3.995 1.438 3.995 3.568s-1.545 3.569-3.995 3.569h-9.107V6.39zm14.54 10.12c3.195-.587 5.858-3.57 5.858-7.777C30.943 4.207 27.641 0 21.09 0H0l3.302 4.207v29.826h18.534c6.551 0 9.96-4.101 9.96-9.214-.16-4.208-3.036-7.83-6.711-8.309zm64.017 4.9L73.338 0H62.473l3.408 4.314v29.772h7.244V11.77l16.297 22.21h6.977V0h-7.297v21.41zM36.056 33.978H60.13v-6.338H43.353v-7.775h13.9v-6.338h-13.9v-7.19h16.883V0h-24.18v33.98z",
    fill: "#AAA",
    mask: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenzinga);
export default __webpack_public_path__ + "static/media/benzinga.18bd0ab596cf6eb4a5ef0cf6f4e3ad1f.svg";
export { ForwardRef as ReactComponent };